<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="download" />

  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section id="downloadpage" style="height: auto !important">

        <section class="download-content">
          <div class="download-header">
            <h1>GB WhatsApp APK Safe Resource Page</h1>
            <p class="download-description">
              We tested GB WhatsApp Apks and find the safe and free source for you. Click the download button to save GB WhatsApp on your Android. We will keep update GB WhatsApp Apk. You can bookmark our site to update the new version regularly.
            </p>
            <img src="@/assets/download/download-1.webp" alt="GB WhatsApp APK Download" class="download-image">
          </div>

          <div class="download-section">
            <h2>GB WhatsApp Download</h2>
            <div class="app-details">
              <div class="app-info">
                <div class="info-item">
                  <span class="label">App Version:</span>
                  <span class="value">18.70</span>
                </div>
                <div class="info-item">
                  <span class="label">App Size:</span>
                  <span class="value">79 MB</span>
                </div>
              </div>
            </div>
            
            <div class="download-button-section">
              <button class="download-btn" @click="download()">
                <img src="@/assets/android.webp" alt="android icon">
                Download GB WhatsApp APK
              </button>
              <p class="download-note">If the downloading does not start from the above download button please <a href="#" @click="download()">click here</a>.</p>
            </div>
          </div>

          <div class="faq-section">
            <h2>FAQ about Download</h2>
            
            <div class="faq-item">
              <h3>How to Download this file?</h3>
              <p>By selecting the Download button, you can quickly download this file. If the link isn't working for you. Please feel free to get in touch with this contact us form.</p>
            </div>

            <div class="faq-item">
              <h3>How to Install GB WhatsApp APK files?</h3>
              <p>After downloading the GB WhatsApp APK file. Follow these steps to install the APK file.</p>
              <ol class="install-steps">
                <li>Firstly, click on Mobile Menu — Settings — Security — Unknown Sources.</li>
                <li>Enable "Unknown Sources".</li>
                <li>After Enabling "Unknown Sources", You can easily Install the application on your Android Device.</li>
              </ol>
            </div>
          </div>
        </section>
      
      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav,
  },
  mounted() {
    //注释下载链接
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      console.log(this.apk);
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.download-content {
  width: 80%;
  margin: 1rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
}

.download-header {
  text-align: center;
  margin-bottom: 40px;
}

.download-header h1 {
  color: #25D366;
  font-size: 2.5em;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  position: relative;
  padding-left: 20px;
}

.download-header h1::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.download-description {
  font-size: 1.1em;
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
  text-align: left;
}

.download-image {
  width: 200px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.download-section {
  margin: 40px 0;
  padding: 30px;
  background: #f8f9fa;
  border-radius: 12px;
  border-left: 4px solid #25D366;
}

.download-section h2 {
  text-align: center;
  color: #25D366;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  position: relative;
  padding-left: 20px;
}

.download-section h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.app-details {
  margin-bottom: 30px;
}

.app-info {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  justify-content: center;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 120px;
}

.info-item .label {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 5px;
}

.info-item .value {
  font-size: 1.2em;
  font-weight: 700;
  color: #25D366;
}

.download-button-section {
  text-align: center;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: white;
  border: none;
  padding: 18px 32px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
  margin-bottom: 15px;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
}

.download-btn img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.download-note {
  color: #666;
  font-size: 0.9em;
}

.download-note a {
  color: #25D366;
  text-decoration: none;
  font-weight: 600;
}

.download-note a:hover {
  text-decoration: underline;
}

.faq-section {
  margin: 40px 0;
}

.faq-section h2 {
  text-align: center;
  color: #25D366;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 30px;
  position: relative;
  padding-left: 20px;
}

.faq-section h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.faq-item {
  margin-bottom: 30px;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 12px;
  border-left: 4px solid #25D366;
}

.faq-item h3 {
  color: #25D366;
  font-size: 1.3em;
  font-weight: 700;
  margin-bottom: 15px;
  position: relative;
  padding-left: 15px;
}

.faq-item h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #25D366, #128C7E);
  border-radius: 2px;
}

.faq-item p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.install-steps {
  background: white;
  padding: 20px 25px;
  border-radius: 8px;
  margin-top: 15px;
}

.install-steps li {
  margin-bottom: 10px;
  line-height: 1.6;
  color: #333;
}

.install-steps li:last-child {
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .download-content {
    padding: 20px 15px;
    width: 100%;
  }
  
  .download-header h1 {
    font-size: 2em;
  }
  
  .download-description {
    font-size: 1em;
  }
  
  .download-btn {
    padding: 15px 25px;
    font-size: 16px;
  }
  
  .download-btn img {
    width: 20px;
    height: 20px;
  }
  
  .app-info {
    flex-direction: column;
    gap: 15px;
  }
  
  .info-item {
    min-width: auto;
    width: 100%;
  }
  
  .faq-item {
    padding: 20px 15px;
  }
  
  .install-steps {
    padding: 15px 20px;
  }
}
</style>